import JSEncrypt from 'jsencrypt'
import Cookies from 'js-cookie'

export const historyRouterState = (url: string) => {
  history.pushState(null, '', url);
}
// url是否存在/
export const hasSlashInPatch = (url: string[]) => {
  let resUrl = ''
  url.forEach(item => {
    const u = item.startsWith('/') ? item : `/${item}`
    resUrl += u.endsWith('/') ? u.slice(0, -1) : u
  })
  return resUrl
}

export const getEncryptedPassword = (str: string): string => {
  const publicKey = process.env.VUE_APP_PUBLIC_KEY as string
  const encrypt = new JSEncrypt()
  encrypt.setPublicKey(publicKey)
  console.log('publicKey', publicKey)
  return encrypt.encrypt(str) || ''
}

export const setCookie = (name:string, value:string) => {
  Cookies.set(name, value)
}

export const getCookie = (name:string) => {
  return Cookies.get(name)
}

export const setLocalstorage = (name:string, value:string) => {
  window.localStorage.setItem(name, value)
}

export const getLocalstorage = (name:string) => {
  return window.localStorage.getItem(name) || ''
}

export const clearLocalstorages = (names:string[] | string = []) => {
  if (Array.isArray(names)) {
    names.forEach(name => {
      setLocalstorage(name, '')
    })
  } else {
    window.localStorage.clear()
  }
}

// 解析 JWT payload 里的 exp(秒级时间戳)，拿不到返回 null。
// 只用于客户端轮询调度，不做任何安全判断 —— 签名校验只能在服务端。
export const getTokenExpireAt = (token: string): number | null => {
  if (!token) return null
  try {
    const payload = token.split('.')[1]
    if (!payload) return null
    // base64url -> base64，补齐 padding
    const b64 = payload.replace(/-/g, '+').replace(/_/g, '/')
    const padded = b64 + '='.repeat((4 - (b64.length % 4)) % 4)
    const json = JSON.parse(window.atob(padded))
    return typeof json.exp === 'number' ? json.exp * 1000 : null
  } catch {
    return null
  }
}
